import { Injectable } from '@angular/core';
import { App } from '@df/core/app';
import { IMetaDataExtended, Meta } from '@df/core/meta/meta';

@Injectable({
    providedIn: 'root'
})
export class GtmProvider {
    /**
     * Store idenfirier like: uk_production
     *
     * GTM usage:
     * function() {
     *     return gtmProvider.sideId
     * }
     */
    readonly siteId = [this.app.dfConfig.ms.siteId, this.app.dfConfig.environment].join('_');

    constructor(
        protected app: App,
        protected meta: Meta,
    ) {
        if (typeof window !== 'undefined') {
            window.gtmProvider = this;
        }
    }

    /**
     * Current page type
     *
     * GTM usage:
     * function() {
     *     return gtmProvider.pageTYpe
     * }
     */
    get pageType(): string | undefined {
        const model = this.meta.model;

        if (model) {
            return model.type;
        }

        const metaPageType = (this.meta.state?.metaData as IMetaDataExtended)?.pageType;

        if (metaPageType) {
            return metaPageType;
        }

        return undefined;
    }
}

declare global {
    interface Window {
        gtmProvider: GtmProvider;
    }
}
